interface SeparatorLineProps {
  color?: string;
  className?: string;
  variant?: SeparatorVariants;
  style?: any;
}
export enum SeparatorVariants {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal'
}

const SeparatorLine = ({
  color,
  className,
  variant,
  style,
  ...rest
}: SeparatorLineProps) => {
  if (variant === SeparatorVariants.VERTICAL) {
    return (
      <div
        className={`separator-line-vertical`}
        style={{ margin: '0 12px', ...style }}
      />
    );
  }

  return (
    <div
      className={`separator_line ${className ? className : 'my-3'}`}
      style={{
        borderBottom: `1px solid ${color ?? '#C5D0E0'}`,
        width: 'auto',
        flexGrow: '1'
      }}
      {...rest}
    />
  );
};

export default SeparatorLine;
